<template>

    <CascoAjanlatBase
        :titleExtra="titleExtra"
        v-if="kobetirVisible()
        || ajanlKobetagVisible()
        || allapUjAutoVisible()
        || cascoElozmenyFedezetVisible()
        || cascoElozmenyKezdeteVisible()
        || allapSzemletVegziVisible()">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="kobetirVisible()" :attributes="kobetir_egyesuleti"/>

                <BnFormField v-if="ajanlKobetagVisible()" :attributes="ajanl_kobetagsag"/>

                <BnFormField v-if="allapUjAutoVisible()" :attributes="tf_allap_ujAuto"/>

                <BnFormField v-if="allapSzemletVegziVisible()" :attributes="tf_allap_SzemletVegzi"/>

                <BnFormField v-if="cascoElozmenyFedezetVisible()" :attributes="casco_elozmeny_fedezet"/>

                <BnFormField v-if="cascoElozmenyKezdeteVisible()" :attributes="casco_elozmeny_kezdet"/>

                <BnFormField
                    v-if="cascoElozmenyKezdeteVisible() && isKobeElozmenyCasco()" :attributes="elozm_torl_datum"/>

                <BnFormField
                    v-if="cascoElozmenyKezdeteVisible() && isKobeElozmenyCasco()" :attributes="elozmeny_casco_modozat"/>

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import { listTypes } from '../../../../../../../../modules/List';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';
import modozat from '../../../../../mixins/modozat';
import { KOBE } from '../../../../../../../../modules/Biztosito';

export default {
    components: { CascoAjanlatBase, BnFormField },
    mixins: [cascoOfferData, modozat],
    methods: {
        allapUjAutoVisible() {
            return this.$store.getters.gepjarmu.kmallas < 5000;
        },
        allapSzemletVegziVisible() {
            return true;
        },
        kobetirVisible() {
            return this.$store.getters.valasztottKgfbBiztosito !== KOBE;
        },
        ajanlKobetagVisible() {
            return this.kobetirEgyesulet === true;
        },
        kobetirChange() {
            this.kobetirEgyesulet = this.$store.getters.tarifaData.kobetir_egyesuleti;
        },
        cascoElozmenyFedezetChange() {
            this.elozmenyFedezet = this.$store.getters.tarifaData.casco_elozmeny_fedezet;
        },
        cascoElozmenyFedezetVisible() {
            return this.$store.getters.vanCascoBonusz;
        },
        cascoElozmenyKezdeteVisible() {
            return this.elozmenyFedezet === true;
        },
        isKobeElozmenyCasco() {
            return this.$store.getters.tarifaData.casco_elozo_biztosito === 6;
        },
    },
    mounted() {
        this.kobetirChange();
        this.cascoElozmenyFedezetChange();
    },
    data() {
        return {
            name: 'AjanlatAdatokB15_V0',
            kobetirEgyesulet: false,
            elozmenyFedezet: false,
            kobetir_egyesuleti: {
                type: 'select',
                label: 'Ön KÖBE egyesületi tag?',
                visible: true,
                editable: true,
                help: true,
                mezo: 'kobetir_egyesuleti',
                path: 'tarifaData.kobetir_egyesuleti',
                itemsText: 'key',
                itemsValue: 'value',
                resource: listTypes.yesno,
                change: this.kobetirChange,
            },
            casco_elozmeny_fedezet: {
                type: 'select',
                // eslint-disable-next-line max-len
                label: 'Töréskár fedezet az előzményszerződésen?',
                visible: true,
                editable: true,
                help: true,
                mezo: 'casco_elozmeny_fedezet',
                path: 'tarifaData.casco_elozmeny_fedezet',
                itemsText: 'key',
                itemsValue: 'value',
                resource: listTypes.yesno,
                change: this.cascoElozmenyFedezetChange,
            },
            casco_elozmeny_kezdet: {
                type: 'date',
                label: 'Casco előzmény szerződés kezdete',
                visible: true,
                editable: true,
                mezo: 'elozm_bonusz_jogkezd_datum',
                path: 'tarifaData.elozm_bonusz_jogkezd_datum',
                help: true,
            },
            elozm_torl_datum: {
                type: 'date',
                label: 'CASCO előzményszerződés megszűnésének dátuma',
                visible: true,
                editable: true,
                mezo: 'elozm_torl_datum',
                path: 'tarifaData.elozm_torl_datum',
                help: true,
            },
            elozmeny_casco_modozat: {
                type: 'select',
                label: 'Előzmény KÖBE CASCO szerződés módozata',
                visible: true,
                editable: true,
                help: true,
                mezo: 'elozmeny_casco_modozat',
                path: 'tarifaData.elozmeny_casco_modozat',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: '911', value: 'KÖBE Casco' },
                    { key: '912', value: 'Lendület Start' },
                    { key: '913', value: 'Lendület Top' },
                ],
            },
            ajanl_kobetagsag: {
                type: 'text',
                label: 'KÖBE-nél lévő biztosítás kötvényszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'ajanl_kobetagsag',
                path: 'tarifaData.ajanl_kobetagsag',
            },
            tf_allap_ujAuto: {
                type: 'select',
                label: 'Új (szalonban vásárolt 0 km-es) autó?',
                visible: true,
                editable: true,
                help: true,
                mezo: 'allapotlap.tf_allap_ujAuto',
                path: 'tarifaData.allapotlap.tf_allap_ujAuto',
                itemsText: 'key',
                itemsValue: 'value',
                resource: listTypes.yesno,
            },
            tf_allap_SzemletVegzi: {
                type: 'select',
                label: 'A szemlét végzi',
                visible: true,
                editable: true,
                help: true,
                mezo: 'allapotlap.tf_allap_SzemletVegzi',
                path: 'tarifaData.allapotlap.tf_allap_SzemletVegzi',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 'U', value: 'Üzletkötő' },
                    { key: 'K', value: 'Szemleközpont' },
                    { key: 'S', value: 'Szakértő' },
                ],
            },

        };
    },
};
</script>
